import { getPath } from '@/router/common'

const baseUrl = {
  title: '入库管理',
  path: 'Warehous80548'
}

export default [
  {
    path: getPath('qgdlinfo80548', baseUrl),
    name: 'Warehous80548_qgdlinfo80548',
    component: () => import(/* webpackChunkName: "Warehous80548_qgdlinfo80548" */ '@/views/warehous80548/qgdlinfo80548/index.vue'),
    meta: {
      title: '清关代理资料'
    }
  },
  {
    path: getPath('rkdinfo80548', baseUrl),
    name: 'Warehous80548_rkdinfo80548',
    component: () => import(/* webpackChunkName: "Warehous80548_rkdinfo80548" */ '@/views/warehous80548/rkdinfo80548/index.vue'),
    meta: {
      title: '入库单资料'
    }
  },
  {
    path: getPath('Addqgdlinfo80548', baseUrl),
    name: 'Warehous80548_Addqgdlinfo80548',
    component: () => import(/* webpackChunkName: "Warehous80548_Addqgdlinfo80548" */ '@/views/warehous80548/addqgdlinfo80548/index.vue'),
    meta: {
      title: '新增修改'
    }
  },
  {
    path: getPath('Addrkdinfo80548', baseUrl),
    name: 'Warehous80548_Addrkdinfo80548',
    component: () => import(/* webpackChunkName: "Warehous80548_Addrkdinfo80548" */ '@/views/warehous80548/addrkdinfo80548/index.vue'),
    meta: {
      title: '新增修改'
    }
  },
]
